module.exports = __webpack_public_path__ + "static/media/email.ff4cea01.svg";